import type { SubscribeWidgetForm } from '@widgets/subscribe/types'
import { phoneService } from '@widgets/shared/services/phoneService'
import subscribeApiService from '@widgets/subscribe/services/subscribeApiService'
import translateService from '@widgets/shared/services/translate/translateService'
import { useWidgetForm, type WidgetFieldsConfig } from '@/composition/widgetForm'
import { ref, type Ref } from '@/composition/vue/compositionApi'
import { TmFakeCountryCode } from '@/services/types'
import type { SubscribeWidgetData } from '@/services/domain/services/forms/subscribe/types'

export const useSubscribeForm = (uniqueCode: string, widgetData: Ref<SubscribeWidgetData | undefined>) => {
  const fieldsConfig: WidgetFieldsConfig<SubscribeWidgetForm> = {
    name: {
      value: '',
      validate: (value) => (!value ? [translateService.t('errors.name')] : []),
    },
    countryCode: {
      value: TmFakeCountryCode,
    },
    phoneNumber: {
      value: '',
      validate: (value) => (!value ? [translateService.t('errors.phoneNumber')] : []),
    },
    consented: {
      value: false,
      validate: (value) =>
        !value && widgetData.value?.isUserConsentEnabled ? [translateService.t('errors.consented')] : [],
    },
    additionalConsented: {
      value: false,
      validate: (value) =>
        !value && widgetData.value?.isUserAdditionalConsentEnabled ? [translateService.t('errors.consented')] : [],
    },
  }

  const submitCallback = async ({ name, countryCode, phoneNumber }) => {
    const payload = {
      name,
      phoneNumber: phoneService.preparePhoneWithCountryCodeForUpload(countryCode, phoneNumber),
    }
    await subscribeApiService.sendMessage(uniqueCode, payload)
    completed.value = true
  }

  const widgetForm = useWidgetForm(fieldsConfig, submitCallback)

  const completed = ref(false)

  return {
    ...widgetForm,
    completed,
  }
}
